#import "../fragments/audience-fragment.graphql"

mutation UpdateAudience($audience: AudienceUpdateInput!) {
    audienceUpdate(input: $audience) {
        audience {
            ...Audience
        }
    }
}
